export async function promiseTuplify(promise) {
  if(!(promise instanceof Promise)) {
    return promise
  }

  try {
    const res = await promise;

    return [res, null];
  } catch(error) {
    return [null, error];
  }
}